import { initializeApp } from 'firebase/app';
import {  getMessaging} from "firebase/messaging";

export const vapidKey = "BAS8zBr06BL-iKUR-97JmMD2kZuHw5IHo_NFY_H2Pddm6MFgtOD2lg_OLK7SsPVCjjsyZkA2NeUfZQUK5BUfDAc"
const firebaseConfig = {
  apiKey: "AIzaSyB7tX9YZCVi7RBit_fGuz23Pjj8NzXzU5c",
  authDomain: "consumer-connect-58667.firebaseapp.com",
  projectId: "consumer-connect-58667",
  storageBucket: "consumer-connect-58667.appspot.com",
  messagingSenderId: "392696596508",
  appId: "1:392696596508:web:4f084d06c403e87399f7d9",
  measurementId: "${config.measurementId}"
};


// my own account
// export const vapidKey = "BAK9drnpLNDWzY9o0PcabSpa0ceC41TsHc_hYdOtoi1hYJx9lkMFMDmVqqUGhRcvQMsyMO-_OrmfbQFQWdKpSOw"
// const firebaseConfig = {
//   apiKey: "AIzaSyAP6slXBSoY4Ufuf697lRmmDVFHlcLIgHo",
//   authDomain: "consumer-connect-e03d4.firebaseapp.com",
//   projectId: "consumer-connect-e03d4",
//   storageBucket: "consumer-connect-e03d4.firebasestorage.app",
//   messagingSenderId: "747650860764",
//   appId: "1:747650860764:web:4f84d2dcf2c3dae8f3d619"
// };


initializeApp(firebaseConfig);

export const messaging = getMessaging();
